// Odpověď `search-api` → model pro `searchRender.js` (issue #67).
// Protějšek `searchNative.js`: oba vracejí TENTÝŽ tvar, takže renderer
// nepozná, odkud data přišla (rozhodnutí #74).
//
// Sekce dostávají VLASTNÍ id (`bs-sgroup-*`), ne nativní (`search-group-*`) —
// nativní uzly na stránce zůstávají (schované) a duplicitní id by rozbilo
// kotvy pilulek.

// API klíč → { kind pro renderer, id kotvy, nadpis }.
// Pořadí odpovídá designu: kategorie → značky → články → stránky.
import L from '../locale/cs/searchApiModel.js';

const SECTIONS = [
  { key: 'categories', kind: 'cats', id: 'bs-sgroup-cats', label: L.cats },
  { key: 'brands', kind: 'brands', id: 'bs-sgroup-brands', label: L.brands },
  { key: 'articles', kind: 'posts', id: 'bs-sgroup-posts', label: L.posts },
  { key: 'pages', kind: 'pages', id: 'bs-sgroup-pages', label: L.pages },
];

/**
 * @param {object} data odpověď `/v1/{tenant}/search`
 * @param {string} query dotaz, jak ho zadal uživatel
 * @param {number} shown kolik karet je právě v mřížce (po loadMore roste)
 * @returns {object} model dle hlavičky `searchRender.js`
 */
export function modelFromApi(data, query, shown, order) {
  const counts = data.counts || {};
  const total = typeof data.total === 'number' ? data.total : 0;
  const rendered = shown === undefined ? (data.products || []).length : shown;
  const chips = resultCategories(data);

  const sections = [];
  SECTIONS.forEach(function (def) {
    // Kategorie z výsledků nahrazují textové hledání v názvech; bez nového pole
    // (API nasazené až po bundlu) zůstává sekce na dnešních datech.
    const found = def.key === 'categories' && chips !== null;
    const items = found ? chips : data[def.key] || [];
    if (!items.length) return; // prázdná sekce se nevykresluje
    sections.push({
      id: def.id,
      kind: def.kind,
      label: def.label,
      // `counts` je zdroj pravdy o celku, délka pole jen o tom, co dorazilo
      count: found ? items.length : typeof counts[def.key] === 'number' ? counts[def.key] : items.length,
      fold: found,
      items: items.map(function (item) {
        return { name: item.name, url: item.url, count: item.count, found: found };
      }),
    });
  });

  return {
    query: query,
    engine: 'typesense',
    order: order || 'relevance',
    // `total` z indexu je skutečný celek → renderer nekreslí „N+" (viz #74)
    products: { present: total > 0, shown: rendered, total: total, hasMore: rendered < total },
    sections: sections,
    chips: chips || [],
  };
}

/**
 * Kategorie spočítané z nalezených produktů (API 2026-10-14,
 * `categories_source: 'results'`), nebo `null` = API je nezná (starší nasazení,
 * generace indexu bez fasety) a čipy se nekreslí. Položka bez jména nebo URL
 * se zahodí, čip by nikam nevedl.
 */
export function resultCategories(data) {
  if (!data || data.categories_source !== 'results') return null;
  return (data.categories || []).filter(function (c) {
    return c && c.name && c.url && typeof c.count === 'number' && c.count > 0;
  });
}

/** Opravený dotaz pro „Mysleli jste: …" — `null`, když API nic nenavrhlo. */
export function didYouMean(data) {
  if (data.corrected_q && data.corrected_q !== data.q) return data.corrected_q;
  const list = data.did_you_mean || [];
  return list.length ? list[0] : null;
}
